import { IMAGE_BASE } from "../Config";

// Default images for different entity types
export const DEFAULT_IMAGES = {
  USER: "/default-profile-image.jpg",
  GROUP: "/default-group-image.jpg",
  PLAY: "/default-play-image.jpg",
  PROGRAM: "/default-play-image.jpg",
  FALLBACK: "/drama.svg" // SVG fallback for any missing images
};

export const getProfileImageUrl = (profileImage: string | null | undefined): string => {
  if (!profileImage) {
    return DEFAULT_IMAGES.USER;
  }

  // Check if it's a Google photo URL
  if (profileImage.includes("googleusercontent.com")) {
    return profileImage;
  }

  // For local uploaded images, use IMAGE_BASE
  return IMAGE_BASE + profileImage;
};

export const getGroupImageUrl = (groupImage: string | null | undefined): string => {
  if (!groupImage || groupImage === "../uploadedImages/unnamed.jpg") {
    return DEFAULT_IMAGES.GROUP;
  }

  // Check if it's a Google photo URL or external URL
  if (groupImage.includes("http")) {
    return groupImage;
  }

  // For local uploaded images, use IMAGE_BASE
  return IMAGE_BASE + groupImage;
};

export const getPlayImageUrl = (playImage: string | null | undefined): string => {
  if (!playImage) {
    return DEFAULT_IMAGES.PLAY;
  }

  // Check if it's a Google photo URL or external URL
  if (playImage.includes("http")) {
    return playImage;
  }

  // For local uploaded images, use IMAGE_BASE
  return IMAGE_BASE + playImage;
};

export const getProgramImageUrl = (programImage: string | null | undefined): string => {
  if (!programImage) {
    return DEFAULT_IMAGES.PROGRAM;
  }

  // Check if it's a Google photo URL or external URL
  if (programImage.includes("http")) {
    return programImage;
  }

  // For local uploaded images, use IMAGE_BASE
  return IMAGE_BASE + programImage;
};

// Generic image URL handler with fallback
export const getImageUrl = (imageUrl: string | null | undefined, type: keyof typeof DEFAULT_IMAGES = 'FALLBACK'): string => {
  if (!imageUrl) {
    return DEFAULT_IMAGES[type];
  }

  // Check if it's a Google photo URL or external URL
  if (imageUrl.includes("http")) {
    return imageUrl;
  }

  // For local uploaded images, use IMAGE_BASE
  return IMAGE_BASE + imageUrl;
};

// Image error handler for onError events
export const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>, fallbackType: keyof typeof DEFAULT_IMAGES = 'FALLBACK') => {
  const target = e.target as HTMLImageElement;
  if (target.src !== DEFAULT_IMAGES[fallbackType]) {
    target.src = DEFAULT_IMAGES[fallbackType];
  }
};